
import API from '@/plugins/axios'

class cesionDerechosService {

    getSubTipoLocal(): Promise<any>{
        return API.get(`cat/subtipolocal`);
    }

    delete(id: number): Promise<any>{
        return API.delete(`cat/RangoCobroPiso/`+ id);
    }

    getConcesionarios(){
        return API.get(`locales-mercados/getConcesionarios`);
      }

    getLocalesMercados(){
        return API.get(`cesion-Derecho/getLocalesMercados`);
      }

    rechazarSolicitudMercado(locacion: any, data: any): Promise<any> {
        return API.post(`cesion-Derecho/rechazarSolicitudcesion/${locacion}`, data);
    }
    
    subirArchivoAutoSec(id: any, data: any): Promise<any> {
        return API.post(`cesion-Derecho/subirArchivoAutoSec/${id}`, data);
    }

    generarArchivo(url: any, data: any, type: any, name: string): Promise<any> {
        return API.request({
            url: url,
            data: data,
            method: type,
            responseType: 'blob'
          });
    }
    
    guardarDocGen(id: any, data: any): Promise<any> {
        return API.post(`cesion-Derecho/guardarDocGen/${id}`, data);
    }
    
    aprovarSolicitud(id: any): Promise<any> {
        return API.post(`cesion-DerechoExterno/aprovarSolicitud/${id}`);
    }

    subirArchivoSolidPago(id: any, data: any): Promise<any> {
        return API.post(`cesion-DerechoExterno/subirArchivoSolidPago/${id}`, data);
    }

    getallsolicitudes(id: string, filters: any): Promise<any>{
        let query = new URLSearchParams(filters).toString();
        return API.get(`cesion-DerechoExterno/getAllSolicitudes/${id}` + '?' + query);
      }
}

export default new cesionDerechosService();